import { Logger } from '@hawtiosrc/core/logging'
import { pluginName } from '../globals'

export const log = Logger.get(`${pluginName}-tree`)
